import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import CustomSpinner from "../../../../../components/CustomSpinner";
import Download from "../../../../../components/SVGComponents/Tools/Download";
import DropDown from "../../../../../components/SVGComponents/Tools/DropDown";
import { STUDY_DOWNLOAD_OPTIONS, USERTYPES } from "../../../../../constants/Constants";
import DownloadOptions from "./DownloadOptions";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { getViewport } from "../../../helpers/CornerstoneViewportService";
import { t } from "i18next";
import themeContext from "../../../../../context/theme/ThemeContext";
import userContext from "../../../../../context/users/UserContext";
import { getEnv } from '../../../../../helpers/EnvHelper';

const DownloadButton = () => {
  const { theme } = useContext(themeContext);
  const { roles, privilegedFirmDoctor } = useContext(userContext);
  const { downloadStudyEnabled,showSavedReport } = useContext(studyviewerContext);
  const downloadOptionRef = useRef(null);
  const [loadingState, setLoadingState] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const { activeViewportIndex } = useContext(ViewportContext);
  const [showOption, setShowOption] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);

  const checkIfActiveViewportIsLoaded = async(e) => {
    
    const viewport = await getViewport(activeViewportIndex);
    console.log("@@@@@" + viewport);
    if(viewport && viewport.imageIds.length > 0) {
      onShowContextualMenu(e);
      setShowOption(true);
    } else {
      setShowOption(false);
    }
  }

  const handleDropDownClick = async (e) => {
    if(!showDropDown) {
      await checkIfActiveViewportIsLoaded(e);
    }
    //setShowDropDown(!showDropDown);
  };

  const handleMouseOver = () => {
    setHovered(true);
    // setShowDropDown(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        downloadOptionRef.current &&
        !downloadOptionRef.current.contains(event.target)
      ) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const hideContextMenu = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowDropDown(false);
      }, 300)
    );
  };

  const onShowContextualMenu = (ev) => {
    ev.preventDefault(); // don't navigate

    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowDropDown(true);
      }, 300)
    );

  };

  useEffect(() => {
    clearTimeout(hideContextMenu);
  }, [showDropDown]);

  return (
    <>
      {loadingState && <CustomSpinner />}
      <div
        style={{ display: "flex", flexDirection: "column", position: "relative" }}
        onClick={handleDropDownClick}
        onMouseEnter={(e)=>{setHovered(true);handleDropDownClick(e)}}
        onMouseLeave={(e)=>{setHovered(false);handleMouseLeave();hideContextMenu()}}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Download color={theme.palette.inactiveTool} />
          {/* <DropDown color={hovered ? "#0085FF" : "#C1C1C1"} /> */}
        </div>
        <div
          ref={downloadOptionRef}
          onMouseEnter={(e)=>{onShowContextualMenu(e);}}
          onMouseLeave={(e)=>{hideContextMenu()}}
          className="viewer-tool-more-dropdown"
          style={{
            display: `${showDropDown ? "flex" : "none"}`,
            flexDirection: "column",
            position: "absolute",
            top: "100%",
            marginTop: "4px",
            zIndex: "99999",
            right: "0",
            left: "unset",
            minWidth: "max-content",
            boxShadow:
              "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
            borderRadius: "5px",
            paddingLeft: "10px",
            paddingRight: "20px",
            // boxShadow: "1px 1px 7px rgba(255, 255, 255, 0.15)"
          }}
        >
          {/* {STUDY_DOWNLOAD_OPTIONS.map((option, index) => {
            return ( */}
          {downloadStudyEnabled && getEnv("REACT_APP_PROTECTED_MODE") == "false" && (
            <div>
              <DownloadOptions
                option={t("button.download-study")}
                setShowDropDown={setShowDropDown}
                index={0}
                setHoveredParent={setHovered}
                setLoadingState={setLoadingState}
                showOption={true}
              />
            </div>
          )}
         {/* <div>
            <DownloadOptions
              option={t("button.download-ppt")}
              setShowDropDown={setShowDropDown}
              index={1}
              setHoveredParent={setHovered}
              setLoadingState={setLoadingState}
              showOption={showOption}
            />
          </div> */}
          <div>
            <DownloadOptions
              option={t("button.download-images")}
              setShowDropDown={setShowDropDown}
              index={2}
              setHoveredParent={setHovered}
              setLoadingState={setLoadingState}
              showOption={showOption}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadButton;
